import { RenderItemProps } from '@shared/components/ui/VirtualList';
import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from '@shared/components/ui/badge';
import { useTranslation } from 'react-i18next';
import { PrintersModel } from '../../models/Printers';
import { DropdownActions } from '../interaction/DropdownActions';
import { cn } from '@shared/utils/utils';

export interface CardProps extends RenderItemProps<PrintersModel> {
  className?: string;
  showActions?: boolean;
  onEdit?: (printer: PrintersModel) => void;
}

export const Card = ({ item: printer, className = '', showActions = true, onEdit = () => {} }: CardProps) => {
  const { t } = useTranslation('printersModule');

  const statusIcon = printer.status === 'online' ? faCircleCheck : faCircleXmark;
  const statusColor = printer.status === 'online' ? 'text-success' : 'text-error';

  return (
    <div className={cn('p-4 border-b border-card-border hover:bg-muted/30 transition-colors', className)}>
      <div className="flex justify-between items-start gap-2">
        {/* Izquierda */}
        <div className="flex-1 space-y-1">
          <div className="flex items-center gap-2">
            <div>
              <FontAwesomeIcon icon={statusIcon} className={cn('w-3 h-3', statusColor)} />
            </div>
            <div>
              <div className="text-sm font-medium line-clamp-2 ">
                {printer.custom_name || printer.name}
                <span className="text-xs text-complementary-text pl-1">
                  {printer.computer && `| ${printer.computer}`}
                </span>
              </div>
            </div>
          </div>

          <Badge variant="outline" className="text-xs font-normal mt-1">
            {printer.id}
          </Badge>

          <div className="text-sm mt-1 font-medium">{printer.active ? t('status.enabled') : t('status.disabled')}</div>
        </div>

        {/* Derecha - Acciones */}
        {showActions && (
          <div>
            <DropdownActions printers={printer} onEdit={onEdit} />
          </div>
        )}
      </div>
    </div>
  );
};
